export const urls = (type, id = "") => {
  switch (type) {
    case "login":
      return "/api/login";
    case "vlogin":
      return "/api/vauth/login";
    case "generateToken":
      return "/generate-token";
    // BNature
    case "getAllBNature":
      return "/api/bnature/all";
    case "creaateBNature":
      return "/api/bnature/create";
    case "deleteBNature":
      return `api/bnature/delete/${id}`;
    case "updateBNature":
      return `api/bnature/update/${id}`;

    // Brands
    case "getAllBrands":
      return "/api/brand/all";
    case "createBrands":
      return "/api/brand/create";
    case "updateBrands":
      return `api/brand/update/${id}`;
    case "deleteBrands":
      return `api/brand/delete/${id}`;
    case "getBrandsByCatID":
      return `api/brand/findById/${id}`;

    //Ribbon
    case "getAllRibbons":
      return "/api/badge/all";
    case "createRibbons":
      return "/api/badge/create";
    case "updateRibbons":
      return `api/badge/update/${id}`;
    case "deleteRibbons":
      return `api/badge/delete/${id}`;

    //Category
    case "getAllCategories":
      return "/api/category/all";
    case "createCategories":
      return "/api/category/create";
    case "updateCategories":
      return `api/category/update/${id}`;
    case "deleteCategories":
      return `api/category/delete/${id}`;

    //SUB Category
    case "getAllSubCategories":
      return "/api/subcat/all";
    case "createSubCategories":
      return "/api/subcat/create";
    case "updateSubCategories":
      return `api/subcat/update/${id}`;
    case "deleteSubCategories":
      return `api/subcat/delete/${id}`;
    case "findByCatId":
      return `api/subcat/findByCategoryId/${id}`;

    // Variants
    case "getAllVariants":
      return "/api/variant/all";
    case "createVariants":
      return "/api/variant/create";
    case "updateVariants":
      return `api/variant/update/${id}`;
    case "getVariantBySubCatID":
      return `api/variant/findBySubcatId/${id}`;
    case "deleteVariants":
      return `api/variant/delete/${id}`;

    // Variants Properties
    case "getAllVariantsProperties":
      return "/api/voptions/all";
    case "createVariantsProperties":
      return "/api/voptions/create";
    case "updateVariantsProperties":
      return `api/voptions/update/${id}`;
    case "deleteVariantsProperties":
      return `api/voptions/delete/${id}`;
    case "findVariantPropById":
      return `/api/voptions/findByVariantId/${id}`;
    case "getAllProducts":
      return "/api/pcatalog/all";
    case "createProducts":
      return "/api/pcatalog/create";
    case "deleteProduct":
      return `api/pcatalog/delete/${id}`;
    case "deleteProductImage":
      return `api/pcatalog/deleteImageById/${id}`;
    case "updateProduct":
      return `api/pcatalog/update/${id}`;

    case "register":
      return "/api/v1/auth/register/";
    case "addAddress":
      return "/api/v1/auth/add_address/";
    case "getAddresses":
      return "/api/v1/auth/get_address/";
    case "allProductsData":
      return "/api/v1/auth/getData/";
    case "bulkuplaod":
      return "/api/v1/auth/uploadbulk/";
    case "addproduct":
      return "/api/v1/auth/addproduct/";
    case "sendmessage":
      return "/api/v1/auth/sendmessage/";
    case "productimages":
      return "/api/v1/auth/productimages/";
    case "test":
      return "/api/v1/auth/test/";
    case "allorders":
      return "/api/v1/auth/userorders/";
    case "createorderid":
      return "/api/v1/auth/orderid/";
    case "capturepayment":
      return "/api/v1/auth/capturepayment";
    case "trackorder":
      return "/api/v1/auth/trackorder";
    case "payementsuccess":
      return "/api/v1/auth/payementsuccess/";
    case "purchasedorders":
      return "/api/v1/auth/purchasedorders/";
    case "productData":
      // return `api/v1/auth/productData/${productName}/'}`
      return `/api/v1/auth/productData/`;
    case "customizedata":
      // return `api/v1/auth/productData/${productName}/'}`
      return `/api/v1/auth/customizedata/`;

    // Admin Dashboard
    case "getusersdata":
      return "/api/v1/auth/getallusers/";
    case "bannersupload":
      return "/api/v1/auth/bannersupload/";

    case "allpayments":
      return "/api/v1/auth/allpayments/";
    case "createorderid":
      return "api/v1/auth/orderid/";

    case "capturepayment":
      return "/api/v1/auth/capturepayment";

    // Admin Dashboard
    case "allpayments":
      return "/api/v1/auth/allpayments/";
    case "overallstats":
      return "/api/v1/auth/overallstats/";

    //Notifications & Settings
    case "notificationSettings":
      return "/api/notificationSettings/";
    case "sendNotificationByType":
      return "/api/notifications/send-by-type";

    //Company Timings
    case "companyTimings":
      return "/api/updateTimings";

    //Roles
    case "getAllRoles":
      return "/api/roles/all";
    case "createRoles":
      return "/api/roles/create";
    case "updateRoles":
      return `api/roles/update/${id}`;
    case "deleteRoles":
      return `api/roles/delete/${id}`;

    //User Management
    case "getAllUsers":
      return "/api/user/all";
    case "getAllUsersById":
      return `/api/user/all?userid=${id}`;
    case "createUsers":
      return "/api/user/create";
    case "updateUsers":
      return `api/user/update/${id}`;
    case "deleteUsers":
      return `api/user/delete/${id}`;
    case "findById":
      return `/api/user/findById/${id}`;

    //Status Tab
    case "getAllStatus":
      return `/api/status/all`;
    case "getStatusById":
      return `/api/status/findById/${id}`;
    case "createStatus":
      return `/api/status/create`;
    case "updateStatus":
      return `api/status/update/${id}`;
    case "deleteStatus":
      return `api/status/delete/${id}`;
    //Logout
    case "logout":
      return `/api/logout`;

    // Vendor AUth
    case "verifyVendor":
      return "/api/vauth/verifyVendor";

    //Vendor Product Management
    case "createVListing":
      return "/api/vlisting/create";
    case "getAllVListing":
      return "/api/vlisting/all";
    case "getAllVListingById":
      return `api/vlisting/all?vendor_id=${id}`;
    case "updateStatusVListing":
      return `api/vlisting/updateStatus/${id}`;
    case "updateVListing":
      return `api/vlisting/update/${id}`;
    case "deleteListingImageById":
      return `api/vlisting/deleteImageById/${id}`;
    case "deleteLProductById":
      return `api/vlisting/delete/${id}`;

    case "createVProducts":
      return "/api/vproducts/create";
    //getting all vendors
    case "getAllVProducts":
      return `api/vproducts/all?vendor_id=${id}`;
    case "getAllVProductsNoId":
      return `/api/vproducts/all`;
    case "getVCategories":
      return "/api/vproducts/fetchCategories";
    case "getAllVProductsNames":
      return "/api/vproducts/fetchProducts";
    case "getVProductsById":
      return `api/vproducts/findProductById/${id}`;
    case "updateVProductsById":
      return `api/vproducts/update/${id}`;
    case "deleteVProductsImageById":
      return `api/vproducts/deleteImageById/${id}`;
    case "deleteVProductById":
      return `api/vproducts/delete/${id}`;

    //Vendor Management
    case "getAllVendors":
      return `/api/vendor/all`;
    case "getNearbyVendors":
      return "/api/main/vendors";
    case "createVendor":
      return `/api/vendor/create`;
    case "updateVendor":
      return `api/vendor/update/${id}`;
    case "vListingCategoriesFindById":
      return `/api/vendor/findById/${id}`;
    case "deleteVendor":
      return `api/vendor/delete/${id}`;

    //Customer Management
    case "getAllCustomers":
      return `/api/customer/all`;
    case "createCustomer":
      return `/api/customer/create`;
    case "updateCustomer":
      return `api/customer/update/${id}`;
    case "deleteCustomer":
      return `api/customer/delete/${id}`;
    case "getCustomerFindById":
      return `/api/customer/findById/${id}`;

    //Delivery Management
    case "getAllDeliveryAgents":
      return `/api/dagent/all`;
    case "createDeliveryAgent":
      return `/api/dagent/create`;
    case "updateDeliveryAgent":
      return `api/dagent/update/${id}`;
    case "deleteDeliveryAgent":
      return `api/dagent/delete/${id}`;
    case "AgentOrders":
      return "/api/agentorders/myOrders";

    //Marketing & Promotions - Sliders
    case "getAllSliders":
      return `/api/banner/all`;
    case "createSlider":
      return `/api/banner/create`;
    case "updateSlider":
      return `api/banner/update/${id}`;
    case "deleteSlider":
      return `api/banner/delete/${id}`;

    //Admin Banners
    case "getAllBanners":
      return `/api/banner/all`;
    case "createBanner":
      return `/api/banner/create`;
    case "updateBanner":
      return `api/banner/update/${id}`;
    case "deleteBanner":
      return `api/banner/delete/${id}`;

    //getAllAdminVendorBanners
    case "getAllAdminVendorBanners":
      return `/api/vbanner/all`;
    case "updateAdminVendorBanners":
      return `api/vbanner/update/${id}`;
    case "deleteAdminVendorBanners":
      return `api/vbanner/delete/${id}`;
    case "updateAdminVendorBannersReason":
      return `api/vbanner/updateReason/${id}`;
    case "updateAdminVendorBannersStatus":
      return `api/vbanner/updateStatus/${id}`;

    //getAllAdminVendorComplaints
    case "getAllAdminVendorComplaints":
      return `/api/complaint/all`;
    case "updateAdminComplaints":
      return `api/complaint/update/${id}`;

    //Admin Coupons
    case "getAllCoupons":
      return `/api/coupon/all`;
    case "createCoupons":
      return `/api/coupon/create`;
    case "updateCoupons":
      return `api/coupon/update/${id}`;
    case "deleteCoupons":
      return `api/coupon/delete/${id}`;

    //Admin Listing
    case "getAllListing":
      return `/api/listing/all`;
    case "getAllListingBasedOnID":
      return `/api/vlisting/all?vendor_id=${id}`;
    case "createListing":
      return `/api/listing/create`;

    case "updateListing":
      return `api/listing/update/${id}`;

    //Change Password:
    case "changePassword":
      return `/api/user/changePassword`;

    //Vendor Notification settings
    case "vendorNotificationSettings":
      return `/api/vauth/notificationSettings`;

    //Vendor Company Timings
    case "vendorCompanyTimings":
      return `/api/vauth/updateTimings`;

    //Vendor Roles
    case "getAllVendorRoles":
      return `/api/vroles/all/${id}`;
    case "createVendorRoles":
      return `/api/vroles/create`;
    case "updateVendorRoles":
      return `api/vroles/update/${id}`;
    case "deleteVendorRoles":
      return `api/vroles/delete/${id}`;

    //Vendor Users
    case "getAllVendorUsers":
      return `/api/vusers/all?userid=${id}`;
    case "getAllVendorUsersById":
      return `/api/vusers/all?userid=${id}`;
    case "createVendorUsers":
      return "/api/vusers/create";
    case "updateVendorUsers":
      return `api/vusers/update/${id}`;
    case "deleteVendorUsers":
      return `api/vusers/delete/${id}`;
    case "findByIdvendors":
      return `/api/vusers/findById/${id}`;

    //Vendor Banners
    case "getAllVendorBanners":
      return `/api/vbanner/all`;
    case "createVendorBanners":
      return `/api/vbanner/create`;
    case "updateVendorBanners":
      return `api/vbanner/update/${id}`;
    case "deleteVendorBanners":
      return `api/vbanner/delete/${id}`;

    //Vendor Bank List
    case "getAllVendorBankDetails":
      return `/api/vbank/list/${id}`;
    case "createVendorBankDetails":
      return `/api/vbank/create`;
    case "updateVendorBankDetails":
      return `api/vbank/update/${id}`;
    case "changePrimaryStatus":
      return `api/vbank/changePrimaryStatus`;
    case "updatePayoutFrequency":
      return `api/vendor/updatePayout`;

    //Vendor Coupons
    case "getAllVendorCoupons":
      return `/api/vcoupon/all`;
    case "createVendorCoupons":
      return `/api/vcoupon/create`;
    case "updateVendorCoupons":
      return `api/vcoupon/update/${id}`;
    case "deleteVendorCoupons":
      return `api/vcoupon/delete/${id}`;

    //Vendor change password
    case "vendorChangePassword":
      return `/api/vauth/changePassword`;

    //Vendor Logout
    case "vendorlogout":
      return `/api/vauth/logout`;
    //Vendor Complaints:
    case "getAllVendorComplaints":
      return `/api/complaint/all`;
    case "createVendorComplaints":
      return `/api/complaint/create`;
    //User Regsiter
    case "userregister":
      return `/api/customer/register`;
    //Verify otp
    case "verifyotp":
      return `/api/customer/verifyOTP`;
    // Become Vendor
    case "becomeVendorSendOtp":
      return "/api/become-vendor/send-otp";
    case "becomeVendorVerifyOtp":
      return "/api/become-vendor/verify-otp";
    case "becomeVendorUpdate":
      return `/api/become-vendor/${id}`;
    //Manage Address
    case "createAdddressForProfile":
      return `/api/address/create`;
    case "getAllManageAddress":
      return `/api/address/all?user_id=${id}`;
    case "setPrimaryAddress":
      return `/api/address/setPrimary`;
    case "updateCustomerAddress":
      return `api/address/update/${id}`;
    case "deleteCustomerAddress":
      return `api/address/delete/${id}`;
    //Create Order
    case "createOrder":
      return `/api/cart/createOrder`;
    //Listing Order Creation
    case "orderCreationForListing":
      return `/api/lvorders/createOrder`;
    //get Orders Based on User Id
    case "getOrderByUserId":
      return `/api/cart/getOrderByUserId/${id}`;
    case "cancelOrder":
      return `api/cart/updateOrderStatus`;
    // Order Management
    case "getOrdersByVendorId":
      return `api/cart/getOrderByVendor?vendor_id=${id}`;
    case "getOrdersByLVendorId":
      return `api/lvorders/getOrderByVendor?vendor_id=${id}`;
    //Logout Pofile
    case "logoutProfile":
      return `/api/customer/logout`;
    case "getdashBoardCounts":
      return `/api/vendor/dashboardCounts/${id}`;
    case "getVendorSalesData":
      return `/api/vendor/salesData/${id}`;
    case "getSalesReport":
      return `/api/vendor/salesReport/${id}`;
    case "getSalesGraphReport":
      return `/api/vendor/salesGraphReport`;
    //getListing orders by User Id
    case "getListingOrdersByUserId":
      return `/api/lvorders/getOrderByUserId/${id}`;
    case "cancelOrderListing":
      return `api/lvorders/updateOrderStatus`;
    case "getMyOrders":
      return "/api/vendor/getMyOrders";
    case "getListingOrders":
      return "/api/lvorders/getMyOrders";
    case "getAllOrders":
      return "/api/agentorders/orders";
    case "getAllSearchAgents":
      return "/api/dagent/all";
    case "PostAssignAgent":
      return "/api/agentorders/assignAgent";
    case "fetchOrderStatus":
      return "/api/agentorders/fetchOrderByStatus";
    //Create Rating
    case "submitRating":
      return "/api/rating/create";
    case "getRequests":
      return `/api/vendor/allrequests?vendor_id=${id}`;
    case "getVendorPaymentRequests":
      return `/api/vendor/allrequests`;
    case "withDrawRequest":
      return `/api/vendor/withdrawalRequest`;

    // Payment Requests
    case "createPaymentOrder":
      return "/api/payment/createOrder";
    case "verifyPaymentOrder":
      return "/api/payment/verifyPayment";

    case "getOverviewMetrics":
      return `/api/adfinancial/metrics`;
    case "getRegularVendorPayments":
      return `/api/adfinancial/vendor-dashboard`;
    case "getAllRequestsAdmin":
      return `/api/vendor/allrequests${id ? `?status=${id}` : ""}`;
    case "updateWithdrawStatus":
      return `/api/vendor/updateWithdrawalStatus/${id}`;
    case "getAllWithdrawls":
      return "/api/agentorders/getAllWithdrawals";
    case "updateAgentWithdrawStatus":
      return `/api/agentorders/updatePaymentStatus`;
    case "getDashboardMetrics":
      return "/api/admin/dashboard";
    case "getrevenueOverview":
      return "/api/adfinancial/revenue-overview";

    case "getActiveStatus":
      return "/api/vendor/updateStatus";
    case "getAgentMetrics":
      return `/api/vendor/agent-metrics?vendor_id=${id}`;
    //Site Settings
    case "getAdminSiteSettings":
      return "/api/admin/site-settings";
    case "updateSiteSettings":
      return "api/admin/site-settings";
    default:
    case "getRatings":
      return "/api/rating/all";
    case "fetchAllOrders":
      return "/api/lvorders/fetchAllOrders";
      break;
  }
};
